// extracted by mini-css-extract-plugin
export default {"formItem":"SWEditCompanyModal_formItem__4up-n"};